<template>
  <Content>
 

  <section class="dashboard-section py-4 py-lg-5">
    <div class="container">
 <div class="row g-3 g-md-4 align-items-start flex-nowrap">
  <!-- سایدبار همواره بغل محتوا بدون شکست خط -->
  <div class="col-auto sidebar-col">
    <DashboardSidebar @logout="onLogout" />
  </div>

  <!-- بخش اصلی تمام فضای باقی‌مانده را پر می‌کند -->
  <main class="col min-w-0">
    <div class="dashboard-content-card">
      <router-view />
    </div>
  </main>
</div>

    </div>
  </section>




  <footerAdmin></footerAdmin>
   
  </Content>
</template>

<script setup>
import { ref, onMounted } from "vue";
import Content from "@/components/AdminContent.vue";
import DashboardSidebar from "@/components/DashboardSidebar.vue";
import footerAdmin from "@/components/AdminFooter.vue";



// import { lang } from "@/plugins/lang";
// import api from "@/plugins/axios";
import { showLoading, hideLoading } from "@/stores/loading";

// import enText from "@/locales/en/AdminDashboard";
// import faText from "@/locales/fa/AdminDashboard";

// const translations = {
//   en: enText,
//   fa: faText,
// };

// const currentLang = computed(() => translations[lang.value]);
const loading = ref(true);

const fetchData = async () => {
  try {
    loading.value = true;
    showLoading();
  } catch (error) {
    loading.value = false;
  } finally {
    loading.value = false;
    hideLoading();
  }
};

onMounted(fetchData);
</script>




<style scoped>
.dashboard-section {
  min-height: 80vh;
}

/* کارت محتوای اصلی داشبورد */
.dashboard-content-card {
  width: 100%;
  min-height: 480px;
  padding: 28px 24px;
  background: rgba(255, 255, 255, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.85);
  border-radius: 28px;
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  box-shadow:
    0 18px 40px rgba(62, 77, 112, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.9);
  transition: box-shadow 0.35s ease;
}

.dashboard-content-card:hover {
  box-shadow:
    0 24px 50px rgba(62, 77, 112, 0.18),
    inset 0 1px 0 rgba(255, 255, 255, 0.95);
}

@media (max-width: 767.98px) {
  .dashboard-content-card {
    padding: 20px 16px;
    border-radius: 22px;
  }
}



/* عرض سایدبار در حالت موبایل/صفحات کوچک */
.sidebar-col {
  width: 220px;
  flex: 0 0 220px;
}

/* عرض سایدبار در تبلت به بالا */
@media (min-width: 768px) {
  .sidebar-col {
    width: 280px;
    flex: 0 0 280px;
  }
}

/* عرض سایدبار در دسکتاپ بزرگ */
@media (min-width: 1200px) {
  .sidebar-col {
    width: 300px;
    flex: 0 0 300px;
  }
}

/* الزامی برای جلوگیری از بیرون‌زدگی محتوای داخل main */
.min-w-0 {
  min-width: 0;
}

</style>
